import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import useFeatureFlags from '../../hooks/useFeatureFlags'
import ViewLoadingFallback from '../ViewLoadingFallback'
import { logError } from '../../utils/logger'

const FeatureGate = ({ flag }) => {
  const isUserLoggedIn = useSelector(state => state.auth.isUserLoggedIn)
  const { isEnabled, isLoading, error } = useFeatureFlags()

  useEffect(() => {
    if (error) logError(error, 'FeatureGate > useFeatureFlags')
  }, [error])

  if (!isUserLoggedIn || isLoading) return <ViewLoadingFallback />

  return isEnabled(flag) ? <Outlet /> : <Navigate to="/" replace />
}

FeatureGate.propTypes = {
  flag: PropTypes.string.isRequired,
}

export default FeatureGate
